/**
 * Mutation rejections normally arrive as Error objects, but Apollo link failures and
 * thrown strings surface here too — so coerce rather than trusting the shape and
 * rendering "[object Object]" at the user.
 */
export function errorMessage(err: unknown): string {
    if (err instanceof Error) return err.message
    return String(err)
}
